import React, { useState } from 'react';
import AlliedLogo from '../../assets/allied-empresas-logo.png';
import { useForm, SubmitHandler, FormProvider } from 'react-hook-form';
import { useAuth } from '../../hooks/useAuth';
import { Input } from '../Input';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import * as S from './styles';

interface IUserData {
  email: string;
  password: string;
}

const schema = yup
  .object({
    email: yup.string().email('E-mail inválido').required('E-mail obrigatório'),
    password: yup.string().required('Senha obrigatória'),
  })
  .required();

export const LoginForm: React.FC = () => {
  const [error, setError] = useState<string>('');

  const methods = useForm<IUserData>({
    resolver: yupResolver(schema),
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const { handleSubmit, getValues, watch } = methods;
  const { isLoading, signIn } = useAuth();

  const onSubmit: SubmitHandler<IUserData> = async user => {
    setError('');
    const response = await signIn(user);

    if (response.status === 500) {
      setError(response.data.error);
    }
  };

  return (
    <S.Container>
      <S.Image src={AlliedLogo} alt="Logo da empresa" />
      <S.Text> Para acessar o Meu Painel, entre com e-mail e senha </S.Text>
      <FormProvider {...methods}>
        <S.Form onSubmit={handleSubmit(onSubmit)}>
          <Input name="email" placeholder="E-mail cadastrado" />
          <Input name="password" type="password" placeholder="Senha" />

          <div data-testid="error-message">
            {error && (
              <S.ErrorText className="required-message">{error}</S.ErrorText>
            )}
          </div>
          <S.LinkWrapper>
            <S.Link href="/esqueci-a-senha">Esqueci minha senha</S.Link>
          </S.LinkWrapper>
          <S.Button className={isLoading ? 'loading' : ''} type="submit">
            {isLoading ? 'Carregando...' : 'Entrar'}
          </S.Button>
          <S.AccessWrapper>
            <S.TextBold> Não tem conta?</S.TextBold>
            <S.LinkBold href="/cadastro/perfis">Solicite seu acesso</S.LinkBold>
          </S.AccessWrapper>
        </S.Form>
      </FormProvider>
    </S.Container>
  );
};
